import React, { useEffect, useRef, useState } from "react";
import Hls from "hls.js";
import {
  startSecureStream,
  stopStream,
  sendHeartbeat,
} from "../../services/streamingService";
import "../../sass/CustomVideoPlayer.scss";

function CameraPlayer({ camera }) {
  const videoRef = useRef(null);
  const hlsRef = useRef(null);
  const heartbeatIntervalRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [streamInitialized, setStreamInitialized] = useState(false);
  const streamIdRef = useRef(`obra_${camera.obraId}_cam_${camera.id}`);

  const startHeartbeat = () => {
    stopHeartbeat();
    heartbeatIntervalRef.current = setInterval(
      () => sendHeartbeat(streamIdRef.current),
      15000,
    );
  };

  const stopHeartbeat = () => {
    if (heartbeatIntervalRef.current)
      clearInterval(heartbeatIntervalRef.current);
  };

  const handlePlayClick = async () => {
    if (streamInitialized) return;
    setIsLoading(true);

    try {
      const data = await startSecureStream(camera.obraId, camera.id);

      const streamUrl = data.streamUrl;
      const video = videoRef.current;

      setStreamInitialized(true);

      setTimeout(() => {
        if (!video) return;
        if (Hls.isSupported()) {
          const hls = new Hls();
          hlsRef.current = hls;
          hls.loadSource(streamUrl);
          hls.attachMedia(video);
          hls.on(Hls.Events.MANIFEST_PARSED, () => {
            video.play().catch((e) => console.error("Erro ao dar play:", e));
            setIsLoading(false);
            startHeartbeat();
          });
        }
      }, 12000);
    } catch (error) {
      console.error("Erro ao iniciar stream:", error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const streamId = streamIdRef.current;
    return () => {
      console.log(`Limpando stream para: ${streamId}`);
      stopHeartbeat();
      if (hlsRef.current) {
        hlsRef.current.destroy();
      }
      stopStream(streamId);
    };
  }, []);

  return (
    <div className="custom-video-player-container">
      <video
        ref={videoRef}
        controls={streamInitialized}
        muted={true}
        className="custom-video-player"
        playsInline
      />
      {!streamInitialized && (
        <div className="video-overlay" onClick={handlePlayClick}>
          <div className="play-button"></div>
        </div>
      )}
      {isLoading && (
        <div className="video-overlay">
          <div className="spinner"></div>
        </div>
      )}
      <div className="camera-name-bar">
        <span>{camera.name}</span>
      </div>
    </div>
  );
}

export default CameraPlayer;
